// meeting.ts — Endpoints analyse CR + parsing DOCX + préparation comité.
import { downloadBlobWithFilename, req, upload } from './_internals.js';

export const meetingApi = {
  // Analyse de CR (wizard meeting). parseDocx prend un File natif (depuis
  // <input type="file">) et renvoie {text, truncated}.
  analyzeMeeting: (text: string) => req('POST', '/meeting/analyze', { text }),
  getMeetingOrigin: () => req('GET', '/meeting/origin'),
  parseDocx: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return upload('/meeting/parse-docx', fd);
  },

  // Préparer un comité — finalize renvoie un Blob (DOCX/PPTX) avec le
  // filename dans Content-Disposition. Centralisé via downloadBlobWithFilename
  // (audit P1 #8) au lieu d'un fetch direct.
  meetingSupportFinalize: (payload: unknown, fallbackName: string): Promise<string> =>
    downloadBlobWithFilename('/meeting-support/finalize', payload, fallbackName),
};
